var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTccLogo = function SvgTccLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "TCCLogo_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 6.714h13.266v13.053H0V6.714Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#TCCLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.19 12.445a7.807 7.807 0 0 1-2.328-4.904 6.672 6.672 0 0 0-3.217-.827c-2.295 0-4.53 1.171-5.755 3.264a6.393 6.393 0 0 0-.66 4.953 6.498 6.498 0 0 0 3.091 3.96 6.679 6.679 0 0 0 5.033.65 6.574 6.574 0 0 0 4.024-3.043c.575-.98.873-2.064.888-3.165a8.122 8.122 0 0 1-1.077-.888",
    fill: "#B38552"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.077 20.713a8.122 8.122 0 0 1-3.421.764 7.955 7.955 0 0 1-3.39-.764 6.671 6.671 0 0 0-3.037 4.042 6.728 6.728 0 0 0 .669 5.1c1.839 3.21 5.924 4.311 9.107 2.457 3.182-1.855 4.274-5.976 2.435-9.185a6.657 6.657 0 0 0-2.363-2.414",
    fill: "#D56A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.332 26.546h-.003a6.63 6.63 0 0 0-3.238.84 8.089 8.089 0 0 1-3.424 5.935 6.619 6.619 0 0 0 1.953 4.608 6.624 6.624 0 0 0 4.712 1.95h.004A6.675 6.675 0 0 0 25 33.21a6.675 6.675 0 0 0-6.668-6.663",
    fill: "#F6B218"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M33.33 20.774a6.625 6.625 0 0 0-5.06-.664 6.625 6.625 0 0 0-4.049 3.108 6.62 6.62 0 0 0-.888 3.252 8.089 8.089 0 0 1 3.405 5.892c3.175 1.78 7.215.678 9.038-2.483a6.672 6.672 0 0 0-2.446-9.105",
    fill: "#B38552"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M26.59 19.046a8.13 8.13 0 0 1 1.321-.486 7.965 7.965 0 0 1 5.51.484c3.117-1.879 4.175-5.954 2.352-9.136a6.63 6.63 0 0 0-4.049-3.13 6.583 6.583 0 0 0-5.058.674 6.673 6.673 0 0 0-3.104 4.084 6.732 6.732 0 0 0 .668 5.102 6.656 6.656 0 0 0 2.36 2.408",
    fill: "#D56A1A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "TCCLogo_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 14,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.729 0h13.26v13.052h-13.26V0Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#TCCLogo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M24.988 6.428a6.43 6.43 0 0 0-1.942-4.519 6.64 6.64 0 0 0-4.686-1.91h-.003c-1.772.002-3.437.681-4.689 1.914a6.432 6.432 0 0 0-1.94 4.616c.001 1.743.692 3.382 1.945 4.614a6.643 6.643 0 0 0 4.687 1.909h.003c1.151-.001 2.257-.29 3.234-.83a7.894 7.894 0 0 1 3.391-5.794",
    fill: "#F6B218"
  }))));
};

export default SvgTccLogo;